import { EAppEnvironment } from '../infrastructure/enums';
import { ProviderConfig } from 'launchdarkly-react-client-sdk/lib/types';
import { LDUser } from 'launchdarkly-js-client-sdk';

export enum ELaunchDarklyEnvId {
    Development = '61446eeda7e1ce25a7deacc3',
    Production = '612e6345ae2fe826b6c7e6a5',
}

export const getLaunchDarklyProviderDetails = (): ProviderConfig => {
    let environment : string = process.env.REACT_APP_ENVIRONMENT ?? EAppEnvironment.Development;
    var ldUser : LDUser = {
            key: 'unidentified',
            custom: {
              userAgent: navigator.userAgent,
              browserVersion: navigator.appVersion,
              environment: environment,
        }
    };
    switch (environment) {
        case EAppEnvironment.Production:
            return {clientSideID: ELaunchDarklyEnvId.Production, user: ldUser};
        default:
            return {clientSideID: ELaunchDarklyEnvId.Development, user: ldUser};
    }
};
